import Sidebar from 'component/Sidebar/sidebar'
import { ChatConnectionProvider } from 'context/chat-connection'
import React from 'react'
import { Outlet } from 'react-router-dom'
import { DocProvider } from './Docs side/docs-context'
import { useAgency } from 'context/agency'
import { useAuth } from 'context/auth'
import { useSSO } from 'context/sso'
import Topbar from 'component/Sidebar/topbar'

function AdminLayout() {
  const { styles } = useAgency()
  const { sso } = useSSO()
  

  const page_bg_color = styles.page_bg_color

  return (
    <ChatConnectionProvider>
      <DocProvider>
        {!sso ? <Sidebar /> :<Topbar /> }
        <main>
          <div
            style={{
              backgroundColor: page_bg_color,
            }}
              className={`p-8 ${!sso ? 'sm:ml-64' : ''} mt-14`}          >
            <Outlet />
          </div>
        </main>
      </DocProvider>
    </ChatConnectionProvider>
  )
}

export default AdminLayout
